import { decryptURL } from './DecryptionService';
import { Parts } from '../constants/constants';

import { Prompt, Variant } from '../interface/Prompt';
import { Content } from '../interface/ContentType';

export const getSpeakingTestContent = async (contentData: Content) => {
    const finalContent: Prompt[] = [];

    // Sort parts by sequence
    contentData.parts.sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
    for (const [partIndex, part] of contentData.parts.entries()) {
        // sort frames by sequence
        part.frames.sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
        for (const [frameIndex, frame] of part.frames.entries()) {
            // sort playlist by sequence
            frame.playlist.sort((a, b) => (a.sequence < b.sequence ? -1 : 1));

            for (const [itemIndex, item] of frame.playlist.entries()) {
                const prompt: Prompt = {
                    ...item,
                    frame: frame.description,
                    partName: part.description,
                    isFirstMessage: partIndex === 0 && frameIndex === 0 && itemIndex === 0,
                    isIntroFrame: partIndex === 0 && frameIndex === 0,
                    noIntentDetection: item.type === 'STATEMENT' ? false : undefined,
                    showTimer: item.subType === 'CARD' ? true : undefined,
                    monologueQuestion: part.description === Parts.PART_2 && item.sequence === 3 ? true : undefined,
                };

                // Decrypt presign url and markdown text
                try {
                    prompt.audioPreSignUrl = await decryptURL(prompt.audioPreSignUrl);

                    if (prompt.markdownText) prompt.markdownText = await decryptURL(prompt.markdownText);
                } catch (error) {
                    console.error('Error decrypting Content URL:', error);
                }

                // decrypt variant presign urls if they exist
                if (item.variants) {
                    prompt.variants = await generateVariants(item.variants);
                }

                finalContent.push(prompt);
            }
        }
    }

    return finalContent;
};

const generateVariants = async (variants: Variant[]): Promise<Variant[]> => {
    const decryptedVariants: Variant[] = [];
    for (const variant of variants) {
        try {
            variant.audioPreSignUrl = await decryptURL(variant.audioPreSignUrl);
            decryptedVariants.push(variant);
        } catch (error) {
            console.error('Error decrypting Variant URL:', error);
        }
    }
    return decryptedVariants;
};
